import React, { useEffect } from 'react';
import "./index.scss"

type ImageryProps = {
    url: string;
    title: string;
    styleText: string;
    isChooseYourOwn: boolean;
}

export const Imagery = ({url, title, styleText, isChooseYourOwn = false}: ImageryProps) => {
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    if (url && title){
      setLoading(false);
    }
  }, [title, url]);

    return (
        loading ? <div className="imagery bg-center relative inset-0 bg-gray-300 animate-pulse rounded-lg"></div>
        : <div className="imagery bg-center relative"
            style={{backgroundImage: `url(${url})`}}>
            {
            isChooseYourOwn && <div className="gift-title">
                <span>Give the Gift </span> <br></br>
                <span>of</span> <span className="highlight">Choice!</span>
            </div>
            }
            <div className={`imagery-title ${styleText ? styleText : null}`}>
                {title}
            </div>
        </div>
    )
}